import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { userConstants } from "./user.constants";

const initialState = {
	loading: false,
	error: null,
	user: {},
	usernameChecked: false,
	isSessionExpired: false,
	permissionLoading: true,
	permissions: [],
	company: null,
	userFirstName: "",
	userLastName: "",
};

export const getCurrentUserId = () => {
	try {
		const currentUserData = JSON.parse(localStorage.getItem("user"));
		return currentUserData.user_id;
	} catch {
		return null;
	}
};

export const getCurrentUserAccessToken = () => {
	try {
		const currentUserData = JSON.parse(localStorage.getItem("user"));
		return currentUserData.access_token;
	} catch {
		return null;
	}
};

const getUserState = state => state.user;

const selector = prop => fp.flow(getUserState, fp.get(prop));

export const getCurrentUserRole = selector("role");
export const getCurrentUserIsAgent = selector("isAgent");

export const getCurrentUserPermissions = selector("permissions");

export const getCurrentUserCompany = selector("company");

export const userProfileNameSelector = state => ({
	firstName: state.user.userFirstName,
	lastName: state.user.userLastName,
});

function user(state = initialState, action) {
	switch (action.type) {
		case userConstants.GET_PERMISSIONS_REQUEST:
			return {
				...state,
				permissionLoading: true,
			};
		case userConstants.GET_PERMISSIONS_SUCCESS:
			return {
				...state,
				error: null,
				permissionLoading: false,
				role: action.permissions.role,
				permissions:
					action.permissions.permissions || action.permissions,
				company: action.permissions.company,
				userFirstName: action.permissions.userFirstName,
				userLastName: action.permissions.userLastName,
				isAgent: action.permissions.isAgent,
			};
		case userConstants.GET_PERMISSIONS_ERROR:
			return {
				...state,
				permissionLoading: false,
				error: action.error,
			};
		case userConstants.PREVENT_LOAD_PERMISSIONS:
			return {
				...state,
				permissionLoading: false,
			};

		case userConstants.SET_SESSION_IS_EXPIRED:
			return {
				...state,
				isSessionExpired: action.isSessionExpired,
			};

		case userConstants.LOGOUT:
			return {
				...state,
				user: {},
				usernameChecked: false,
				loading: false,
			};

		case userConstants.LOGIN_FAILURE: {
			return {
				...state,
				loading: false,
				error: action.error,
			};
		}
		case userConstants.FORGOT_PASSWORD_SUCCESS:
			return {
				...state,
				message: action.message,
				showForgotPasswordSuccessPage: true,
			};
		case userConstants.RESET_PASSWORD_SUCCESS:
			return {
				...state,
				message: action.message,
				showResetPasswordSuccessPage: true,
			};
		case userConstants.VERIFY_CODE_FAILURE:
			return {
				...state,
				message: action.message,
				showResetPasswordLinkErrorPage: true,
			};
		case userConstants.SET_USER_PROFILE_NAME:
			return {
				...state,
				userFirstName: action.firstName,
				userLastName: action.lastName,
			};
		default:
			return state;
	}
}

// permissionLoading prevent rendering any components before permissions would be loaded.
// We don't need load new permissions on logout (no user - no permissions)
// So we overlap permissionLoading from initialvalues
export default withResetState({
	initialState: { ...initialState, permissionLoading: false },
})(user);
